const genCollapseMotion = token => ({
  [token.componentCls]: {
    // For common/openAnimation
    ["".concat(token.antCls, "-motion-collapse-legacy")]: {
      overflow: 'hidden',
      '&-active': {
        transition: "height ".concat(token.motionDurationMid, " ").concat(token.motionEaseInOut, ",\n        opacity ").concat(token.motionDurationMid, " ").concat(token.motionEaseInOut, " !important")
      }
    },
    ["".concat(token.antCls, "-motion-collapse")]: {
      overflow: 'hidden',
      transition: "height ".concat(token.motionDurationMid, " ").concat(token.motionEaseInOut, ",\n        opacity ").concat(token.motionDurationMid, " ").concat(token.motionEaseInOut, " !important")
    }
  }
});
export default genCollapseMotion;